import moment from 'moment';
import {joinedValuesSeparator, dateFormat} from '@/ts/DefaultTableConfigs';

export default class BalanceAccountItem {

    public date: string;
    public type: string;
    public amount: number;
    public balance: number;
    public orderId: string;
    public status: string;
    public rowType: string;

    constructor(
         date: string,
         type: string,
         amount: number,
         balance: number,
         orderId: string,
         status: string = null,
         rowType: string = null,
    ) {
        this.date =  moment(date).local().format(dateFormat);
        this.type = type;
        this.amount = amount;
        this.balance = balance;
        this.orderId = orderId;
        this.status = status;
        this.rowType = rowType;
    }

    get momentDate() {
        return moment(this.date, dateFormat);
    }

    public compareDateAndReturnIfNotExists(date: any) {
        return typeof date === 'undefined' ? true : this.momentDate.isSameOrAfter(date.date);
    }
}
